export { ColorPicker as default } from './ColorPicker'
import css from './styles.styl'
import { insertCss } from 'insert-css'
insertCss(css)
